/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Feature_2Inputs */

const en_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher rate limits`)
};

const id_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limit lebih tinggi`)
};

const ms_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Had kadar lebih tinggi`)
};

const ca_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límits de tases més alts`)
};

const cs_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyšší limity`)
};

const da_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Højere prisgrænser`)
};

const de_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höhere Tarifgrenzen`)
};

const et_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kõrgemad ülemmäärad`)
};

const es_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de tasas más altos`)
};

const fr_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites plus élevées`)
};

const hr_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veći limiti`)
};

const it_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limiti maggiori`)
};

const lv_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augstāki pieprasījumu limiti`)
};

const lt_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didesnės užklausų ribos`)
};

const hu_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magasabb árfolyamhatárok`)
};

const nl_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hogere limieten`)
};

const nb_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Høyere hastighetsgrenser`)
};

const pl_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyższe limity zapytań`)
};

const pt_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de taxa mais altos`)
};

const ro_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite de rată mai ridicate`)
};

const sk_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyššie limity`)
};

const sl_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Višje omejitev zahtevkov`)
};

const fi_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korkeammat käyttörajat`)
};

const sv_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Högre beloppsgränser`)
};

const vi_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giới hạn tỷ lệ cao hơn`)
};

const tr_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha yüksek kullanım sıklığı limitleri`)
};

const el_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Υψηλότερα όρια`)
};

const bg_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По-високи ограничения на скоростта`)
};

const ru_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Более высокие лимиты`)
};

const sr_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Већа ограничења`)
};

const uk_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підвищені ліміти`)
};

const ka_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`უფრო მაღალი ტარიფების ლიმიტები`)
};

const hi_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हायर रेट लिमिट्स `)
};

const th_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขีดจำกัดอัตราที่สูงกว่า`)
};

const ko_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 높은 요청 한도`)
};

const zh_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速率限制更宽松`)
};

const zh_tw_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更高的速率限制`)
};

const ja_leo_feature_2 = /** @type {(inputs: Leo_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高い上限設定`)
};

/**
* | output |
* | --- |
* | "Higher rate limits" |
*
* @param {Leo_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_feature_2 = /** @type {((inputs?: Leo_Feature_2Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Feature_2Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_feature_2(inputs)
	if (locale === "ms") return ms_leo_feature_2(inputs)
	if (locale === "ca") return ca_leo_feature_2(inputs)
	if (locale === "cs") return cs_leo_feature_2(inputs)
	if (locale === "da") return da_leo_feature_2(inputs)
	if (locale === "de") return de_leo_feature_2(inputs)
	if (locale === "et") return et_leo_feature_2(inputs)
	if (locale === "es") return es_leo_feature_2(inputs)
	if (locale === "fr") return fr_leo_feature_2(inputs)
	if (locale === "hr") return hr_leo_feature_2(inputs)
	if (locale === "it") return it_leo_feature_2(inputs)
	if (locale === "lv") return lv_leo_feature_2(inputs)
	if (locale === "lt") return lt_leo_feature_2(inputs)
	if (locale === "hu") return hu_leo_feature_2(inputs)
	if (locale === "nl") return nl_leo_feature_2(inputs)
	if (locale === "nb") return nb_leo_feature_2(inputs)
	if (locale === "pl") return pl_leo_feature_2(inputs)
	if (locale === "pt") return pt_leo_feature_2(inputs)
	if (locale === "ro") return ro_leo_feature_2(inputs)
	if (locale === "sk") return sk_leo_feature_2(inputs)
	if (locale === "sl") return sl_leo_feature_2(inputs)
	if (locale === "fi") return fi_leo_feature_2(inputs)
	if (locale === "sv") return sv_leo_feature_2(inputs)
	if (locale === "vi") return vi_leo_feature_2(inputs)
	if (locale === "tr") return tr_leo_feature_2(inputs)
	if (locale === "el") return el_leo_feature_2(inputs)
	if (locale === "bg") return bg_leo_feature_2(inputs)
	if (locale === "ru") return ru_leo_feature_2(inputs)
	if (locale === "sr") return sr_leo_feature_2(inputs)
	if (locale === "uk") return uk_leo_feature_2(inputs)
	if (locale === "ka") return ka_leo_feature_2(inputs)
	if (locale === "hi") return hi_leo_feature_2(inputs)
	if (locale === "th") return th_leo_feature_2(inputs)
	if (locale === "ko") return ko_leo_feature_2(inputs)
	if (locale === "zh") return zh_leo_feature_2(inputs)
	if (locale === "zh-tw") return zh_tw_leo_feature_2(inputs)
	if (locale === "ja") return ja_leo_feature_2(inputs)
	return en_leo_feature_2(inputs)
});